import React from 'react';
import FormRender from "v4/components/form/FormRender/FormRender";
import { usePolTranslation } from "v4/hooks/usePolTranslation";
import useViewOrdersSelection
    from "v4/pages/admin/ViewOrders/components/ViewOrdersSelection/hooks/useViewOrdersSelection";

export default function ViewOrdersSelection() {
    const { t } = usePolTranslation();
    const { methods, form } = useViewOrdersSelection();

    return (
        <div className="new-view-orders__selection">
            <h3>{t('pick_form_to_edit')}</h3>

            <FormRender form={form} methods={methods}/>
        </div>
    )
}
